<div class="card {{cssClass}}" *transloco="let t; read: 'ime.manufacturing.datasets'">
  <div class="card-body">
    <div class="d-flex">
      <h5 class="d-inline my-auto">
        <ng-container *ngIf="isItem; else datasetTitle">
          {{t( 'Datasets')}}
        </ng-container>
        <ng-template #datasetTitle>
          {{t( 'Item Connections')}}
        </ng-template>
      </h5>
      <button class="btn btn-sm btn-outline-primary ms-auto" *ngIf="!readonly" (click)="add()">
        <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
        {{t('Add')}}
      </button>
    </div>
    <p-table *ngIf="container.ItemInItemGroups?.length"
             styleClass="p-datatable-xs p-datatable-borderless white-rows p-inner-table-auto mt-1"
             [value]="container.ItemInItemGroups"
             [rowHover]="true"
             [autoLayout]="false"
             [rowTrackBy]="trackById"
             [paginator]="container.ItemInItemGroups?.length > 10"
             [showCurrentPageReport]="true"
             [rowsPerPageOptions]="[10,25,50,100,200]"
             [(rows)]="rowsPerPage"
             [(first)]="firstRow"
             [customSort]="true"
             (sortFunction)="customSort($event)"
             currentPageReportTemplate="{first} to {last} of {totalRecords}"
             dataKey="Id">
      <ng-template pTemplate="header">
        <tr>
          <th class="wx-48" pSortableColumn="Sequence" title="{{t('Sequence')}}">
            #
            <p-sortIcon field="Sequence"></p-sortIcon>
          </th>
          <th *ngIf="isItem; else itemColumn" class="min-wx-192" pSortableColumn="ItemGroupId">
            {{t('Item Group')}}
            <p-sortIcon field="ItemGroupId"></p-sortIcon>
          </th>
          <ng-template #itemColumn>
            <th class="min-wx-192" pSortableColumn="ItemId">
              {{t('Item')}}
              <p-sortIcon field="Item"></p-sortIcon>
            </th>
          </ng-template>
          <th style="width: 170px">
            {{t('From/To')}}
          </th>
          <th pSortableColumn="TypeClv">
            {{t('Type')}}
            <p-sortIcon field="TypeClv"></p-sortIcon>
          </th>
          <th style="width: 76px"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr class="p-selectable-row">
          <td pEditableColumn class="parent">
            <p-cellEditor>
              <ng-template pTemplate="output">
                <div class="d-flex w-100">
                  <ng-container *ngIf="!row.Sequence && !readonly" [ngTemplateOutlet]="editIcon" [ngTemplateOutletContext]="{columnName: 'ime.manufacturing.datasets.#'}"></ng-container>
                  <span class="ms-auto">{{row.Sequence}}</span>
                </div>
              </ng-template>
              <ng-template pTemplate="input">
                <input mesStopArrowKeyPropagation type="number" class="form-control" id="Sequence-{{row.Id}}" name="Sequence-{{row.Id}}" [readonly]="readonly" [(ngModel)]="row.Sequence" (ngModelChange)="changed.emit()">
              </ng-template>
            </p-cellEditor>
          </td>
          <td *ngIf="isItem; else itemCell" pEditableColumn mesStopClickPropagation class="text-wrap text-break parent">
            <p-cellEditor *ngIf="!row.$isNew; else selectItemGroupTmpl">
              <ng-template pTemplate="output">
                <ng-container *ngIf="!row.ItemGroupId && !readonly; else itemGroupTmpl" [ngTemplateOutlet]="editIcon" [ngTemplateOutletContext]="{columnName: 'ime.manufacturing.datasets.Item Group'}"></ng-container>
                <ng-template #itemGroupTmpl>
                  <span [ngClass]="{'fw-bold': row.isActiveMain()}">
                    <app-item-group-display-name [itemGroupId]="row.ItemGroupId"/>
                  </span>
                </ng-template>
              </ng-template>
              <ng-template pTemplate="input">
                <ng-template [ngTemplateOutlet]="selectItemGroupTmpl"></ng-template>
              </ng-template>
            </p-cellEditor>
            <ng-template #selectItemGroupTmpl>
              <mes-web-manufacturing-item-group-select [items$]="itemGroupsQuery.getAll$"
                                                       name="itemGroup-{{row.Id}}" id="itemGroup-{{row.Id}}"
                                                       [entityId]="row.ItemGroupId"
                                                       (entityIdChange)="row.ItemGroupId = $event; row.$isNew = false" [readonly]="readonly" [initOpened]="true"/>
            </ng-template>
          </td>
          <ng-template #itemCell>
            <td pEditableColumn mesStopClickPropagation class="text-wrap text-break parent">
              <p-cellEditor *ngIf="!row.$isNew; else selectItemTmpl">
                <ng-template pTemplate="output">
                  <ng-container *ngIf="!row.ItemId && !readonly; else itemTmpl" [ngTemplateOutlet]="editIcon" [ngTemplateOutletContext]="{columnName: 'ime.manufacturing.datasets.Item'}"></ng-container>
                  <ng-template #itemTmpl>
                    <span [ngClass]="{'fw-bold': row.isActiveMain()}">
                      <app-item-display-name [itemId]="row.ItemId"/>
                    </span>
                  </ng-template>
                </ng-template>
                <ng-template pTemplate="input">
                  <ng-template [ngTemplateOutlet]="selectItemTmpl"></ng-template>
                </ng-template>
              </p-cellEditor>
              <ng-template #selectItemTmpl>
                <mes-web-manufacturing-item-select [items$]="itemsQuery.getAll$"
                                                   name="item-{{row.Id}}" id="item-{{row.Id}}"
                                                   [entityId]="row.ItemId"
                                                   (entityIdChange)="row.ItemId = $event; row.$isNew = false" [readonly]="readonly" [initOpened]="true"/>
              </ng-template>
            </td>
          </ng-template>
          <td pEditableColumn mesStopClickPropagation class="parent">
            <p-cellEditor>
              <ng-template pTemplate="output">
                <ng-container *ngIf="!row.FromDate && !row.ToDate && !readonly; else fromToTmpl" [ngTemplateOutlet]="editIcon" [ngTemplateOutletContext]="{columnName: 'ime.manufacturing.datasets.From/To'}"></ng-container>
                <ng-template #fromToTmpl>
                  <div>
                    {{row.FromDate | date: 'dd.MM.yyyy'}} - {{row.ToDate | date: 'dd.MM.yyyy'}}
                  </div>
                </ng-template>
              </ng-template>
              <ng-template pTemplate="input">
                <mes-date-range-picker [fromDate]="row.FromDate" [toDate]="row.ToDate" [format]="'dd.MM.yyyy'" [hasButton]="false" [small]="false" [disabled]="readonly" [initOpened]="true"
                                       (dateSelect)="setDateRange($event, row)"/>
              </ng-template>
            </p-cellEditor>
          </td>
          <td pEditableColumn mesStopClickPropagation class="parent">
            <p-cellEditor>
              <ng-template pTemplate="output">
                <ng-container *ngIf="!row.TypeClv && !readonly" [ngTemplateOutlet]="editIcon" [ngTemplateOutletContext]="{columnName: 'ime.manufacturing.datasets.Type'}"></ng-container>
                {{ classificatorValuesQuery.selectEntity(row.TypeClv) | async | displayName }}
              </ng-template>
              <ng-template pTemplate="input">
                <mes-web-classificator-value-select name="type-{{row.Id}}" id="type-{{row.Id}}" [entityId]="row.TypeClv" [readonly]="readonly" [dropDownCssClass]="null"
                                                    [items$]="classificatorValuesQuery.itemInItemGroupTypes$" [initOpened]="true"  (entityIdChange)="row.TypeClv = $event; changed.emit()"/>
              </ng-template>
            </p-cellEditor>
          </td>
          <td style="white-space: nowrap">
            <button class="btn btn-sm btn-outline-primary me-1" (click)="open(row)">
              <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#arrow-top-right-on-square"></svg>
            </button>
            <button *ngIf="!readonly" class="btn btn-sm btn-outline-danger" (click)="remove(row)">
              <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#trash"></svg>
            </button>
          </td>
        </tr>
      </ng-template>
      <ng-template #editIcon let-columnName="columnName">
        <span class="show-on-parent-hover text-gray-400 text-nowrap">
          {{columnName | transloco}}
          <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#pencil"></svg>
        </span>
      </ng-template>
    </p-table>
  </div>
</div>
